module.exports = __webpack_public_path__ + "static/media/upload-file.52353d9a.svg";